import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import deleteScheduledReport from "api/scheduledReports/deleteScheduledReport";
import handleInvalidateError from "helpers/handleInvalidateError";
import { scheduledReportsKey } from "queryKeys/scheduledReportsKey";

export default function useDeleteScheduledReportMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteScheduledReport,
    onSuccess: (data) => {
      toast.success(data?.message || "Scheduled Report deleted successfully!");

      queryClient
        .invalidateQueries({ queryKey: scheduledReportsKey() })
        .catch(handleInvalidateError);
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to delete report.");
    },
  });
}
